import React from "react";

interface PriceDisplayProps {
  currentPrice: number;
  originalPrice: number;
  isUnitPrice?: boolean;
}

export const PriceDisplay: React.FC<PriceDisplayProps> = ({
  currentPrice,
  originalPrice,
  isUnitPrice = false,
}) => {
  const hasDiscount =
    Math.round(originalPrice * 100) > Math.round(currentPrice * 100);
  const width = isUnitPrice ? "w-16" : "w-20";

  return (
    <div className={`${width} text-center`}>
      {hasDiscount ? (
        <div className="flex flex-col">
          <div className="text-sm text-red-500 line-through text-center">
            {originalPrice?.toFixed(1)}
          </div>
          <div className="text-sm font-medium text-gray-900 text-center">
            {currentPrice?.toFixed(1)}
          </div>
        </div>
      ) : (
        <div className="text-sm font-medium text-gray-900">
          {currentPrice?.toFixed(1)}
        </div>
      )}
    </div>
  );
};
